<template>
    <div>
        <certificate v-if="routerPath === 'certificate'"/>
        <ganme v-if="routerPath === 'ganma'" />
        <serialno v-if="routerPath === 'serialno'"/>
    </div>  
</template>

<script>
import certificate from './Certificate/CertificateSearch'
import ganme from './Ganme/Ganme'
import serialno from './Serialno/Serialno'
export default {
    components: {
        certificate,
        ganme,
        serialno
    },
    computed: {
        routerPath () {
            let length = this.$route.path.length
            return this.$route.path.substr(1).substring(0,length - 6)
        }
    }
}
</script>
